import type { AnalyticsPlacementTypes } from '@core/analytics'

export type TPlaybackIntent = 'play' | 'pause' | 'next' | 'previous'

const STALE_AFTER_MS = 10000

type TPending = { placement: AnalyticsPlacementTypes; setAt: number }

const INTENTS: TPlaybackIntent[] = ['play', 'pause', 'next', 'previous']

const slots: Record<TPlaybackIntent, TPending | null> = {
    play: null,
    pause: null,
    next: null,
    previous: null,
}

export const setPlaybackContext = (
    intent: TPlaybackIntent,
    placement: AnalyticsPlacementTypes,
): void => {
    // Clear other intent slots — last user action wins. Without this, a stale intent (e.g. an
    // unconsumed 'play' from before a pause click) could be picked up on a later `playing` event
    // instead of the most recent intent.
    INTENTS.forEach(key => {
        slots[key] = null
    })
    slots[intent] = { placement, setAt: Date.now() }
}

export const consumePlaybackContext = (intent: TPlaybackIntent): AnalyticsPlacementTypes => {
    const slot = slots[intent]
    slots[intent] = null
    if (!slot) {
        return 'unset'
    }

    return Date.now() - slot.setAt > STALE_AFTER_MS ? 'unset' : slot.placement
}
